import { render, staticRenderFns } from "./ApportionmentDetails.vue?vue&type=template&id=29544a9c&scoped=true"
import script from "./ApportionmentDetails.vue?vue&type=script&lang=js"
export * from "./ApportionmentDetails.vue?vue&type=script&lang=js"
import style0 from "./ApportionmentDetails.vue?vue&type=style&index=0&id=29544a9c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29544a9c",
  null
  
)

export default component.exports